import { Link } from 'react-router-dom';
import { trpc } from '../lib/trpc';
import { SectionLoading } from '../components/ui/LoadingSpinner';
import { FeaturedWineryCard } from '../components/FeaturedWineryCard';
export const Home = () => {
  const { data: wineryData, isLoading: wineriesLoading } = trpc.venue.listRandom.useQuery({ count: 4 });

  return (
    <div className="mt-2 sm:mt-0">
      {/* Hero Section */}
      <section
        className="relative bg-stone-900 text-white py-20 md:py-32 px-6 text-center bg-cover bg-center rounded-lg overflow-hidden"
        style={{ backgroundImage: 'url(/napa_vineyard.jpg)' }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-10">
        <h1 className="font-sans text-4xl md:text-6xl font-bold mb-4">
          Discover Wineries and Wine Bars
        </h1>
        <p className="text-stone-300 text-lg md:text-xl max-w-2xl mx-auto mb-10">
          Explore curated wineries and unforgettable tasting experiences across the finest wine regions.
        </p>
        <Link
          to="/wineries"
          className="inline-block border border-white/60 text-white px-8 py-3 rounded-sm text-sm tracking-[0.15em] uppercase hover:bg-white/10 transition-colors"
        >
          Explore Wineries
        </Link>
        </div>
      </section>

      {/* Featured Wineries Section */}
      <section className="pt-2 pb-0 md:pt-8 md:pb-0">
        <h2 className="font-sans text-lg font-medium tracking-[0.25em] uppercase text-stone-400 mb-6 md:mb-8 text-center">
          Featured
        </h2>
        {wineriesLoading ? (
          <SectionLoading message="Loading featured wineries..." />
        ) : wineryData?.items && wineryData.items.length > 0 ? (
          <div className="space-y-6">
            {wineryData.items.map((venue, index) => (
              <FeaturedWineryCard key={venue._id} venue={venue} index={index} />
            ))}
          </div>
        ) : (
          <p className="text-center text-stone-400">No featured wineries available yet.</p>
        )}
      </section>

      {/* Featured Experiences Section — hidden for now */}
    </div>
  );
};
